
import React, { Component}  from 'react';
import styled from 'styled-components';
import { TariffPointServicesForm } from './FormPointServices'


const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledTariffPointForm = styled.div`
  display: grid;
  grid-template-columns: 34px 1fr 110px;
  grid-gap: 10px;
  margin-bottom: 20px;

  .address {
    color: #828282;
    word-break: break-word;
  }
`;


export class TariffPointForm extends Component {

  render() {
    const { context, point, index } = this.props;

    return (
      <StyledTariffPointForm>
        <div className={'pt-5'}>
          <Index>{index + 1}</Index>
        </div>
        <div className={'pt-10'}>
          {point.name}
          {point.address && (
            <React.Fragment>, <span className={'address'}>{point.address}</span></React.Fragment>
          )}
        </div>
        <div>
          <TariffPointServicesForm
            context={context}
            point={point}
          />
        </div>
      </StyledTariffPointForm>
    )
  }
}
